import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../../../Modal';
import Spinner from '../../../Spinner';
import Form, { FormBody, FormActions, TextInput } from '../../../Form';

@inject('surveyTemplateStore', 'surveyTopicStore')
@observer
class SurveyTemplateModify extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  }

  @observable item = {
    name: '',
    description: '',
  };

  @observable topicOptions = [];

  slug = 'monitoring/survey/template';
  title = '';

  componentWillMount() {
    const { params: { id }, surveyTopicStore } = this.props;
    this.editMode = id !== 'add';
    this.topicOptions = surveyTopicStore.items.map(item => ({ topic_id: item.id, name: item.name, checked: false, seq: 0 }));
    if (this.editMode) {
      this.title = 'Edit Survey Template';
      this.reset();
    } else this.title = 'Add Survey Template';
  }

  @action reset = () => {
    const { params: { id }, surveyTemplateStore } = this.props;
    const foundItem = surveyTemplateStore.findById(id);
    if (foundItem) {
      this.item = foundItem.asJson;
      this.topicOptions.forEach(topic => {
        let foundTopic = foundItem.topics.find(item => item.topic_id === topic.topic_id);
        if (!!foundTopic) {
          topic.checked = true;
          topic.required = foundTopic.required || 0;
          topic.seq = foundTopic.seq || 0;
        }
      })
      foundItem.topics.forEach(item => this.topicOptions.find(topic => +topic.topic_id === +item.topic_id).checked = true);
    }
  }

  @action onChange = (e, field) => this.item[field] = e.target.value;

  handleSave = (e) => {
    e.preventDefault();

    const { surveyTemplateStore } = this.props;
    const { notify, router } = this.context;

    const payload = Object.assign({}, toJS(this.item), {
      topics: this.topicOptions.filter(item => item.checked).map(item => ({ topic_id: item.topic_id, required: item.required, seq: item.seq }))
    })

    // console.log(payload); return;

    let modifyPromise = this.editMode ? surveyTemplateStore.updateItem(payload) : surveyTemplateStore.createItem(payload);
    modifyPromise
      .then(() => {
        notify.success({ message: 'Success' });
        router.push(this.slug);
      })
      .catch(err => {
        notify.error(err);
      });
  }

  toggleSelect = (id, item) => {
    if (!!id && id.indexOf('checkbox') > -1) return;
    item.checked = !item.checked;
    if (item.checked) item.seq = this.topicOptions.filter(item => item.checked).length - 1
  }

  _renderTable = ({ caption, id, data, showCheck }) => {
    return (
      <div className='DataTable' style={{ minWidth: '400px', minHeight: '400px', maxHeight: '60vh', overflowY: 'auto' }}>
        <table>
          <caption>{caption}</caption>
        </table>
        <table>
          <thead>
            <tr>
              <th>Topic</th>
              {showCheck && <th>Required</th>}
            </tr>
          </thead>
          <tbody>{data.sort((a, b) => a.seq < b.seq ? -1 : 1).map((item, i) => (
            <tr key={`survey-template-${id}-topic-${item.topic_id}-available`} style={{ cursor: 'pointer' }} onClick={(e) => this.toggleSelect(e.target.id, item)}>
              <td>{item.name}</td>
              {showCheck && <td><input id={`checkbox_${item.name}`} type='checkbox' checked={+item.required === 1} onChange={() => { item.required = ~item.required + 2; this.forceUpdate(); }} /></td>}
            </tr>
          ))}</tbody>
        </table>
      </div>
    )
  };

  render() {
    const { surveyTemplateStore, params: { id } } = this.props;

    let availableTopic = this.topicOptions.filter(item => !item.checked);
    let selectedTopic = this.topicOptions.filter(item => item.checked);
    console.log(toJS(selectedTopic))

    return (
      <Modal title={this.title} slug={this.slug} isLoading={surveyTemplateStore.isLoading} isSaving={surveyTemplateStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Name'} value={this.item.name} onChange={e => this.onChange(e, 'name')} />
            <TextInput label={'Description'} value={this.item.description} onChange={e => this.onChange(e, 'description')} />
            <div className='flex flex-row space-between full-width overflow-x-scroll'>
              {this._renderTable({ caption: 'Available Topic', id, data: availableTopic })}
              <span style={{ width: '20px' }} />
              {this._renderTable({ caption: 'Selected Topic', id, data: selectedTopic, showCheck: true })}
            </div>
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default SurveyTemplateModify;



// WEBPACK FOOTER //
// ./src/components/Maintenance/Survey/SurveyTemplate/SurveyTemplateModify.js